import {
  SET_ADMIN_STATE
} from './CONSTANTS';

const initialState = {
  isAdmin: false
};

const admin = function (state = initialState, action) {
  switch (action.type) {
    case SET_ADMIN_STATE:
      return {...state, isAdmin: action.value};
    default:
      return state;
  }
};

export default admin;



// WEBPACK FOOTER //
// ./src/admin/reducer.js